// Remise en haut de page à chaque navigation ET à chaque rechargement (Marc, 02/08).
//
// Le bug d'origine : React Router change de route sans toucher au défilement, et le
// navigateur conserve l'offset de la page précédente. En cliquant « Collectivités » depuis
// le bas de l'accueil, on arrivait à y=927 sur une page haute de 2045 — en bas d'une page
// qu'on n'avait jamais lue. Même symptôme au rechargement (F5), cette fois parce que c'est
// le navigateur qui restaure la position, après le montage de React.
//
// La règle est volontairement SIMPLE : on arrive en haut, sauf si l'URL porte une ancre.
// J'ai d'abord tenté de préserver la restauration du navigateur sur Retour/Avance, avec une
// mémorisation maison par entrée d'historique. Ça marche mal ici : nos pages n'ont pas leur
// hauteur finale au remontage (la grille tarifaire et les exemples arrivent par API), donc
// le scroll est écrêté et on atterrit à mi-page — un comportement à la fois faux et
// imprévisible. Entre une restauration approximative et un comportement constant, le
// constant vaut mieux : c'est aussi ce que font la plupart des sites.
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

// `manual` neutralise la restauration automatique du navigateur, seule façon fiable de
// reprendre la main au rechargement — sans elle, notre `scrollTo` au montage est écrasé.
if (typeof history !== 'undefined' && 'scrollRestoration' in history) {
  history.scrollRestoration = 'manual'
}

export default function ScrollToTop() {
  const { pathname, hash } = useLocation()

  useEffect(() => {
    // Une URL qui porte un hash : c'est l'ancre qui décide où atterrir, pas nous.
    if (hash) return
    // 'instant' et non 'smooth' : un changement de page doit se comporter comme un
    // chargement de page, pas comme un défilement animé depuis le contenu précédent.
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
  }, [pathname, hash])

  return null
}
